import { ErrorCodes, GqlValidationError } from "config/types";

import { AppError, POLLING_ERROR_CODES, normalizeSubclassArgs } from "./AppError";
import { AppErrorOptions, AppErrorSource } from "./error.input.types";

/**
 * Transient async-processing polling states.
 *
 * These are not failures — they are retry sentinels indicating the backend
 * is not yet ready with a result. Consumed entirely by the retry link.
 * Never reported to Elastic APM.
 */
export class PollingError extends AppError {
  static readonly codes = POLLING_ERROR_CODES;
  readonly type = "polling" as const;

  constructor(
    source: AppErrorSource | AppError | ErrorCodes | string,
    optionsOrMessage?: AppErrorOptions | string,
    validationErrors?: GqlValidationError[]
  ) {
    super(...normalizeSubclassArgs(source, optionsOrMessage, validationErrors));
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "PollingError";
  }

  /** Always returns true — overrides AppError.isPolling() */
  isPolling(): boolean {
    return true;
  }
}
